import {
  IonText,
  useIonToast,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
} from "@ionic/react";
import React from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userState, viewState } from "../../../atoms";
import { viewProviders } from "../../../constants/global";
import { copyOutline } from "ionicons/icons";

const Upload = () => {
  const { billingEmail } = useRecoilValue(userState);
  const setView = useSetRecoilState(viewState)
  const [present] = useIonToast();

  const presentToast = (position?: 'top' | 'middle' | 'bottom') => {
    present({
      message: 'Email address copied',
      duration: 3000,
      position: position
    }).then(r => r);
  };

  return (
    <IonGrid>
      <IonRow>
        <IonCol size="12">
          <IonText className="settings-col-title">Adding bills is easy. Select one of the options below:</IonText>
        </IonCol>
        <IonCol size="12" className="settings-upload-col-list">
          <IonText className="settings-upload-text number">1.</IonText>
          <IonText className="settings-upload-text">
            Email your bills to <span
            onClick={() => {
              navigator.clipboard.writeText(billingEmail).then((email) => email);
              presentToast()
            }}
          >{billingEmail} <IonIcon icon={copyOutline}/>
            </span>
          </IonText>
        </IonCol>
        <IonCol size="12" className="settings-upload-col-list">
          <IonText className="settings-upload-text number">2.</IonText>
          <IonText className="settings-upload-text">
            Contact your providers and update your email address to <span
            onClick={() => {
              navigator.clipboard.writeText(billingEmail).then((email) => email);
              presentToast()
            }}
          >{billingEmail} <IonIcon icon={copyOutline}/>
            </span>
          </IonText>
        </IonCol>
        <IonCol size="12" className="settings-upload-col-list">
          <IonText className="settings-upload-text number">3.</IonText>
          <IonText className="settings-upload-text">
            <IonText className="link-authentication" onClick={() => setView(viewProviders)}>Select your providers</IonText> and sign the authorisation then we'll update your billing details for you.
          </IonText>
        </IonCol>
      </IonRow>
    </IonGrid>
  )
}

export default Upload
